export default {
  SET_PERIOD(state, period) {
    state.period = period
  },
  SET_CALENDAR_RANGE(state, range) {
    state.calendarRange = range
  },
  SET_SELECTED_IO_IDS(state, insertionOrderIds) {
    state.selectedInsertionOrderIds = insertionOrderIds
  },
  SET_BILLING_PERIOD_IDS(state, billingPeriodIds) {
    state.selectedBillingPeriodIds = billingPeriodIds
  },
  SET_LOADING(state, flag) {
    state.loading = flag
  },
  SET_INSERTION_ORDERS(state, insertionOrders) {
    state.insertionOrders = insertionOrders
  },
  SET_REPORT_DATA(state, totalReportData) {
    state.reportData = totalReportData
  },
  SET_DAILY_REPORT_DATA(state, dailyReportData) {
    state.dailyReportData = dailyReportData
  },
  SET_CAMPAIGN_REPORT_DATA(state, { key, data, campaignId }) {
    if (!state.campaignReportData[key] || !campaignId) {
      state.campaignReportData[key] = data
    } else {
      state.campaignReportData[key].data = state.campaignReportData[
        key
      ].data.map(report => {
        if (report.campaignId === campaignId) {
          if (data.data.length === 0) {
            return {
              budgets: report.budgets,
              campaign: report.campaign,
              campaignId: report.campaignId,
              insertionOrder: report.insertionOrder,
              insertionOrderBudgetIds: report.insertionOrderBudgetIds,
              insertionOrderId: report.insertionOrderId,
            }
          } else {
            return data.data[0]
          }
        } else {
          return report
        }
      })
    }
  },
  SET_CAMPAIGNS(state, { key, data }) {
    state.campaigns[key] = data
  },
  SET_DELIVERY_GROUP_REPORT_DATA(state, { key, data }) {
    state.deliveryGroupReportData[key] = data
  },
  SET_SELECTED_CAMPAIGN_BUDGET_IDS(state, { campaignId, campaignBudgetIds }) {
    state.selectedCampaignBudgetIds[campaignId] = campaignBudgetIds
  },
}
